export default __webpack_public_path__ + "roboto-v27-latin-italic.45bb88c2a9b6a4bb6e4d932a1649c4b7.ttf";